import React from 'react';
import EDIconButton from '../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import { UIUrvalConditionObjectType } from '../../../../../Types/UrvalTypes';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';
import { URVAL_INDENT } from '../../../Consts/UrvalConsts';
import { createAssocLabel } from '../../UrvalFieldPicker/Utils/UrvalConditionUtils';

interface IProps {
  displayLabel: string;
  conditionObject: UIUrvalConditionObjectType;
  deleteConditionObject: () => void;
  indention: number;
  disabled?: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'right',
    paddingRight: 24,
    marginTop: 12,
    minHeight: 36,
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  extendedValue: {
    justifyContent: 'space-between',
  },
  /** Styles applied to root element if conditionObject is a value condition */
  valueConditionLabel: {
    marginTop: 14,
  },
  labelContainer: {
    textAlign: 'start',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      minHeight: 32,
    },
  },
  labelContainerNoAssocName: {
    alignItems: 'center',
  },
  assocLabel: {
    opacity: 0.6,
    fontSize: theme.typography.pxToRem(10),
    lineHeight: 1,
  },
});

class ConditionLabel extends React.Component<IProps> {
  render() {
    const {
      displayLabel,
      deleteConditionObject,
      conditionObject,
      classes,
      indention,
      disabled,
    } = this.props;

    const isValuecondition =
      conditionObject.type === 'String' || conditionObject.type === 'Numeric';

    const isExtendedCondition = conditionObject.type === 'Extended';

    const textColor = disabled ? 'textSecondary' : 'inherit';

    return (
      <div
        className={classNames(classes.root, {
          [classes.extendedValue]: isExtendedCondition,
          [classes.valueConditionLabel]:
            isValuecondition || isExtendedCondition,
          [classes.labelContainerNoAssocName]:
            !conditionObject.modelPath ||
            conditionObject.modelPath.length === 0,
        })}
        style={{ paddingLeft: indention * URVAL_INDENT }}
      >
        {isExtendedCondition && (
          <EDIconButton
            color="inherit"
            icon="close"
            tooltip={`Ta bort ${displayLabel}`}
            onClick={deleteConditionObject}
            margin={'0 0 0 -12px'}
          />
        )}
        <div
          className={classNames({
            [classes.labelContainer]: !isExtendedCondition,
          })}
        >
          <EDTypography
            variant="caption"
            color={textColor}
            className={classes.assocLabel}
          >
            {createAssocLabel(conditionObject.modelPath)}
          </EDTypography>
          <EDTypography bold={isExtendedCondition} color={textColor}>
            {displayLabel}
          </EDTypography>
        </div>
      </div>
    );
  }
}

export default withStyles(ConditionLabel, styles);
